import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectors as authSelectors } from 'auth';
import { selectors as sessionSelectors } from 'session';
import { api } from 'app/services';
import actions from 'session/actions';

const useRegulatoryConsent = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const activeOrganization = useSelector(sessionSelectors.activeOrganization);

  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const organizationId = activeOrganization?.id;
  const shouldShowConsent = activeOrganization?.showCifraConsentPopup;

  useEffect(() => {
    if (!isAuthenticated || !organizationId || !shouldShowConsent) {
      setIsOpen(false);
      return;
    }

    setIsOpen(true);
  }, [isAuthenticated, organizationId, shouldShowConsent]);

  const accept = async () => {
    if (!organizationId) return;

    setIsSubmitting(true);
    try {
      const { error } = await api.submitCifraConsent(organizationId);
      if (error) throw error;

      dispatch(actions.organizationShowCifraConsent(false));
      setIsOpen(false);
    } catch (error) {
      setIsOpen(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isOpen, isSubmitting, accept };
};

export default useRegulatoryConsent;
